namespace advisorop.components.advisor {
    
    class RTQController {
        $router;
        rtqId: number;        
        rtqType: number;
        needToSelectInvestor: boolean = false;
        rtq: domains.IRTQ;
        question: domains.IQuestion;
        questionIndex: number;
        results: Array<domains.IQuestionResult>;
        result: domains.IQuestionResult;
        questionnaire: domains.IQuestionnaire;
        selInvestor;
        investorPreselected: boolean = false;

        static $inject = ["identityService", "advisorService"];
        constructor(private identityService: services.IdentityService,
            private advisorService: services.AdvisorService) {
            this.rtq = {};
        }


        searchInvestor(searchTerm: string): ng.IPromise<{}> {
            return this.advisorService.searchInvestors(searchTerm, null, null).then((response) => {
                return response.data;
            });
        }

        onSelectInvestor(item, model, label, event): void {
            this.rtq.title = item;
            this.rtq.title.companyGroup = null;
            this.rtq.titleId = item.id;
            this.needToSelectInvestor = false;
        }

        clearInvestor(): void {
            this.rtq.title = null;
            this.rtq.titleId = 0;
            this.needToSelectInvestor = true;
            this.selInvestor = null;
        }        


        nextQuestion(): void {
            if (this.questionnaire.questions.length > (this.questionIndex+1)) {
                this.questionIndex++;
                this.question = this.questionnaire.questions[this.questionIndex];
                if (this.rtqId && this.rtqId > 0)
                {
                    //we need to find answer for current question
                    this.result = this.results.filter(item => item.questionId == this.question.id)[0];
                }
                else {
                    this.result = this.results[this.questionIndex];
                }
            }
        }

        previousQuestion():void {
            if (this.questionIndex > 0 && this.questionnaire.questions.length > (this.questionIndex-1)) {
                this.questionIndex--;
                this.question = this.questionnaire.questions[this.questionIndex];
                this.result = this.results[this.questionIndex];
            }
        }

        saveRTQ(): void {       
            var r = this.$router;                 
            this.advisorService.saveRTQ(this.rtq)
                .success((data) => {
                    toastr.success("RTQ has been successfully saved.");
                    r.navigate(["InvestorDetails", { id: this.rtq.titleId }]);
                })
                .error((data, status) => {
                    toastr.error("RTQ has not been saved! Error " + status + " " + data);
                });            
        }

        finishRTQ(): void {
            var r = this.$router;     
            this.rtq.questionnaireResult.status = 1;
            this.advisorService.saveRTQ(this.rtq)
                .success((data) => {
                    toastr.success("RTQ has been successfully completed.");
                    this.$router.navigate(["InvestorDetails", { id: this.rtq.titleId }]);
                })
                .error((data, status) => {
                    toastr.error("RTQ has not been saved! Error " + status + " " + data);
                });
            
        }
        
        $onInit(): void {            
        }

        $routerOnActivate(next, previous) {

            this.rtqId = 0;
            if (next.params.rtqId)
                this.rtqId = <number>next.params.rtqId;

            this.rtq.titleId = 0;
            if (next.params.investorId) {
                this.rtq.titleId = <number>next.params.investorId;
                this.investorPreselected = true;
            }
            else
                this.investorPreselected = false;
            
            this.rtqType = 0;
            if (next.params.rtqType)
                this.rtqType = <number>next.params.rtqType;
            
            this.needToSelectInvestor = this.rtq.titleId == 0;  

            if (this.rtqId && this.rtqId > 0)
            {
                this.advisorService.getRTQ(this.rtqId)
                    .success((data) => {
                        this.rtq = data;                        
                        this.rtq.title.companyGroup = null;                  
                        this.questionnaire = this.rtq.questionnaireResult.questionnaire;                        
                        this.results = this.rtq.questionnaireResult.results;
                        this.questionIndex = -1;
                        this.nextQuestion();
                    })
                    .error((data, status) => {
                        toastr.error("Error " + status + " " + data);
                    });
            }
            else {
                this.advisorService.getNewRTQ(this.rtqType)
                    .success((data) => {
                        data.titleId = this.rtq.titleId;
                        this.rtq = data;                        
                        this.questionnaire = this.rtq.questionnaireResult.questionnaire;
                        this.results = this.rtq.questionnaireResult.results;
                        this.questionIndex = -1;
                        this.nextQuestion();
                        //only if we have preselected individual
                        if (this.rtq.titleId > 0) {
                            this.advisorService.getInvestor(this.rtq.titleId).success((data) => {
                                data.companyGroup = null;
                                this.rtq.title = data;
                            }).error((data, status) => {
                                toastr.error("Error " + status + " " + data);
                            });
                        };

                    })
                    .error((data, status) => {
                        toastr.error("Error " + status + " " + data);
                    });
            }
        }

    }


    class RTQ implements ng.IComponentOptions {
        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        public $routeConfig: any;

        constructor() {
            this.controller = RTQController;
            this.controllerAs = "vm";
            this.bindings = {
                $router: "<"
            };
            this.templateUrl = "spa/advisor-module/views/rtq.html";
        }

    }
    angular.module(Constants.APP).component("rtq", new RTQ());


}